import { shallowEqual, useSelector } from 'react-redux';
import type { StateWithPsaps } from './psapInfoSlice';
import { selectActiveCapabilities } from './psapInfoSlice';

const selectCurrentPSAP = (state: StateWithPsaps) => state.psaps.currentPSAP;
export function useCurrentPSAP() {
  const currentPSAP = useSelector(selectCurrentPSAP);

  if (!currentPSAP) {
    throw new Error('No current PSAP available.');
  }
  return currentPSAP;
}

export function useCurrentPSAPAccountID() {
  return useSelector(
    (state: StateWithPsaps) => state.psaps.currentPSAP.account_id,
  );
}

export function useActiveCapabilities() {
  return useSelector(selectActiveCapabilities);
}

export function usePSAPSmartPhraseContext() {
  return useSelector(
    (state: StateWithPsaps) => ({
      accountId: state.psaps.currentPSAP?.account_id,
      agencyName: state.psaps.currentPSAP?.name,
      agencyState: state.psaps.currentPSAP?.state,
      contactName: state.psaps.currentPSAP?.contact_name,
      contactTitle: state.psaps.currentPSAP?.contact_title,
      contactPhone: state.psaps.currentPSAP?.contact_phone,
      contactEmail: state.psaps.currentPSAP?.contact_email,
      nonEmergencyPhone: state.psaps.currentPSAP?.non_emergency_phone,
    }),
    shallowEqual,
  );
}
